module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasePage', {
    attrs: {
      "title": "Folder"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [(_vm.loading) ? _c('Loader', {
    staticClass: "ml-4"
  }) : _c('div', {
    staticClass: "column is-10-desktop is-offset-1-desktop"
  }, [_c('div', {
    staticClass: "columns flex-column-reverse-is-mobile"
  }, [_c('div', {
    staticClass: "column is-narrow max-width-300px-if-not-mobile"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('FolderSection'), _vm._v(" "), _c('GroupsSection')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('nav', {
    staticClass: "breadcrumb is-large"
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "pl-0",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [(!_vm.editing) ? _c('span', {
    staticClass: "ml-2 d-flex flex-wrap align-items-center"
  }, [_c('FolderIcon', {
    staticClass: "mr-2",
    attrs: {
      "width": "28px",
      "height": "35px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v(_vm._s(_vm.folder.title))]), _vm._v(" "), (_vm.folder.shared) ? _c('SharedWithUsersIcon', {
    attrs: {
      "width": "1.5rem",
      "height": "1.5rem"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "my-tag ml-2 p-4"
  }, [_vm._v(_vm._s(_vm.videoCount))])], 1) : _c('span', {
    staticClass: "ml-2 level-item justify-content-start align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedName),
      expression: "editedName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.editedName)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.save($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editedName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "buttons d-flex ml-1"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    class: _vm.loading && 'is-loading',
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])]), _vm._v(" "), (!_vm.editing) ? _c('a', {
    staticClass: "button is-link",
    on: {
      "click": function($event) {
        _vm.editing = true
      }
    }
  }, [_vm._v("edit")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mb-4 flex-wrap-reverse-if-mobile"
  }, [_c('div', {
    staticClass: "d-flex align-items-center w-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "input mt-0 br-0 mr-2",
    attrs: {
      "type": "search",
      "placeholder": "search in folder"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "d-flex align-items-center if-not-mobile",
    on: {
      "click": function($event) {
        _vm.rows = true
      }
    }
  }, [_c('BarsIcon', {
    attrs: {
      "fill": "#dbdbdb",
      "width": "25px"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "pl-2 d-flex align-items-center mr-2 if-not-mobile",
    on: {
      "click": function($event) {
        _vm.rows = false
      }
    }
  }, [_c('TableIcon', {
    attrs: {
      "fill": "#dbdbdb",
      "width": "25px"
    }
  })], 1)]), _vm._v(" "), (!_vm.loading && _vm.userID == _vm.folder.owner) ? _c('button', {
    staticClass: "button is-info w-100-if-mobile mb-4-if-mobile mr-1",
    attrs: {
      "type": "button",
      "name": "share folder"
    },
    on: {
      "click": function($event) {
        _vm.showShareModal = true
      }
    }
  }, [_vm._v("\n            Share Folder\n          ")]) : _vm._e(), _vm._v(" "), (_vm.showShareModal && !_vm.loading) ? _c('ShareFolderModal', {
    attrs: {
      "folder": _vm.folder
    },
    on: {
      "close": function($event) {
        _vm.showShareModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('button', {
    staticClass: "button is-danger w-100-if-mobile mb-4-if-mobile mr-1",
    attrs: {
      "type": "button",
      "name": "share folder"
    },
    on: {
      "click": function($event) {
        _vm.showConfirm = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.label) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('Confirm', {
    attrs: {
      "show": _vm.showConfirm,
      "message": _vm.confirmMessage,
      "title": _vm.label,
      "confirmFocus": true,
      "completeButtonText": 'Remove'
    },
    on: {
      "confirm": function($event) {
        _vm.leaveFolder(_vm.folder.id)
      },
      "cancel": function($event) {
        _vm.showConfirm = false
      }
    }
  })], 1), _vm._v(" "), (_vm.loading) ? _c('section', {
    staticClass: "d-flex justify-content-center w-100 align-items-center"
  }, [_c('Loader')], 1) : _vm._e(), _vm._v(" "), _c('section', [_c('VideosTable', {
    class: _vm.rows ? 'rows' : 'grid',
    attrs: {
      "videos": _vm.videosResults
    }
  }), _vm._v(" "), (_vm.nothingFound && !_vm.emptyFolder) ? _c('div', {
    staticClass: "d-flex align-items-center flex-column"
  }, [_c('p', {
    staticClass: "text-muted text-center fs-2rem break-word"
  }, [_vm._v("\n            No videos found matching: "), _c('strong', [_vm._v(_vm._s(_vm.query))])])]) : _vm._e(), _vm._v(" "), (_vm.emptyFolder) ? _c('div', [_c('p', {
    staticClass: "text-muted text-center fs-2rem"
  }, [_vm._v("This folder is empty")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted text-center fs-1rem"
  }, [_vm._v("Add a video with the "), _c('b', [_vm._v("Move to Folder")]), _vm._v(" button on the video's page.")])]) : _vm._e()], 1)])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-aa4267a0"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Folder.vue
// module id = 1079
// module chunks = 0